export const FORM_GUIDES = [
  {
    id: "FIN_UPI",
    title: "UPI / QR Code Payment Fraud",
    context: "Victim is tricked into approving a 'Collect Request' (PIN entered) or scanning a QR code sent via WhatsApp, falsely believing they are receiving money. Money is deducted instantly.",
    evidence: [
      { field: "12-Digit RRN", desc: "The exact 12-digit UPI Reference Number from the bank SMS (e.g., 3192xxxxxxxx)." },
      { field: "Beneficiary VPA", desc: "The UPI ID the money was sent to (e.g., scammer@ybl, 9999999999@paytm)." },
      { field: "Exact Amount", desc: "The exact debited amount down to the rupee." }
    ],
    mapping: "Enter the RRN into the 'Transaction ID' field. Ensure the date of the transaction matches the SMS timestamp perfectly.",
    taxonomy: "Must be classified as 'UPI / QR Code Fraud'. Do NOT classify as 'E-commerce Fraud' even if the scam started over an OLX listing.",
    fatal_error: "Entering the victim's own UPI ID instead of the beneficiary's, or entering an 11-digit mobile number instead of the 12-digit RRN."
  },
  {
    id: "FIN_INV",
    title: "Cryptocurrency / Trading Scam",
    context: "Victim is added to a Telegram group and convinced to deposit funds into a fake trading application. The app shows massive fake profits, but charges 'withdrawal taxes' when they try to pull out.",
    evidence: [
      { field: "Multiple UTRs", desc: "Every single NEFT/RTGS UTR (16-22 alphanumeric characters) for all deposits made over the weeks." },
      { field: "Mule Account Details", desc: "Beneficiary Bank Account numbers and IFSC codes." }
    ],
    mapping: "Map each transfer as a separate financial entry on the portal. Do NOT sum them up into one entry. Map the exact beneficiary account for each.",
    taxonomy: "Classify strictly under 'Investment Scam' or 'Cryptocurrency Fraud'.",
    fatal_error: "Recording the fake 'Profit' shown on the scam app dashboard as the 'Amount Lost'. Only record the ACTUAL money transferred from the victim's bank."
  },
  {
    id: "FIN_ARREST",
    title: "Digital Arrest / Extortion",
    context: "Victim receives a terrifying Skype call from 'Customs' or 'CBI' claiming a parcel with narcotics was found in their name. Victim transfers funds to a 'safe RBI account' for verification.",
    evidence: [
      { field: "Beneficiary Account", desc: "The exact bank account number given by the scammer." },
      { field: "Beneficiary IFSC", desc: "The 11-character IFSC (4 letters + 0 + 6 characters)." },
      { field: "IMPS UTR", desc: "12-digit transaction reference." }
    ],
    mapping: "In the narrative section, clearly state 'Digital Arrest - Impersonation of Law Enforcement'. Map the financial details perfectly to trigger the T1 block.",
    taxonomy: "Classify as 'Impersonation of Govt Official / Digital Arrest'.",
    fatal_error: "Putting the IFSC code into the Account Number field, which instantly fails the T1/T2 bank API freeze."
  },
  {
    id: "FIN_AEPS",
    title: "AePS Biometric Cloning Fraud",
    context: "Victim notices multiple ₹10,000 deductions via their passbook. No OTP was ever received. They are usually from a rural area.",
    evidence: [
      { field: "POS Merchant ID", desc: "The illicit merchant ID visible on the bank passbook entry." },
      { field: "RRN/Txn ID", desc: "The transaction reference from the passbook." }
    ],
    mapping: "Since there is no beneficiary account (it's a POS withdrawal), map the POS Terminal ID into the merchant field. Advise victim to lock biometrics.",
    taxonomy: "Classify as 'Aadhaar Enabled Payment System (AePS) Fraud'.",
    fatal_error: "Interrogating the victim for 'Who did you share the OTP with?' (No OTP is generated in AePS fraud). Failing to advise them to lock biometrics on UIDAI."
  },
  {
    id: "FIN_BEC",
    title: "Business Email Compromise (BEC)",
    context: "Corporate finance team wires a massive amount (Lakhs/Crores) to a new vendor account after receiving an urgent, spoofed email from their CEO.",
    evidence: [
      { field: "NEFT/RTGS UTR", desc: "The high-value transaction reference number." },
      { field: "Swift Code", desc: "If it was an international wire, the Swift Code of the destination bank." },
      { field: "Spoofed Email", desc: "The exact fraudulent email address (e.g., ceo@co-mpany.com instead of ceo@company.com)." }
    ],
    mapping: "This is a Golden Hour priority. Input the UTR immediately to trigger the corporate banking block.",
    taxonomy: "Classify as 'Business Email Compromise' under Corporate Fraud.",
    fatal_error: "Wasting time trying to parse the email headers over the phone before filing the financial block. The block MUST be filed first."
  }
];

export const INTAKE_DROPDOWNS = [
  {
    category: "Reporter Roles (Pre-Screening)",
    items: [
      { label: "An individual (Self)", desc: "Use when the victim themselves is on the line. Preferred for accuracy." },
      { label: "An individual (On Behalf)", desc: "Use for elderly victims or minors where a relative is reporting. You must capture the actual victim's details." },
      { label: "Organization", desc: "Use ONLY for corporate frauds like BEC or corporate ransomware." },
      { label: "Anonymous", desc: "Use for reporting child pornography or terrorism tips. Do NOT use for financial fraud (requires bank details)." }
    ]
  },
  {
    category: "Police Station Jurisdiction Mapping",
    items: [
      { label: "Cyber Crime Police Station (CCPS)", desc: "Select this if the fraud amount is greater than ₹5 Lakhs, or involves complex corporate/crypto fraud." },
      { label: "Local Police Station", desc: "Select for standard localized financial frauds (under ₹5 Lakhs) or localized harassment cases." }
    ]
  },
  {
    category: "Golden Hour Delay Flags",
    items: [
      { label: "Within 0-2 Hours", desc: "CRITICAL PRIORITY. The T1/T2 API has a 90% success rate of freezing funds if caught here." },
      { label: "Within 2-24 Hours", desc: "HIGH PRIORITY. Funds may have moved to mule accounts, but can still be traced and frozen in Tier-2 jumps." },
      { label: "Beyond 24 Hours", desc: "STANDARD PRIORITY. The money has likely been converted to crypto or withdrawn via ATMs. Freeze probability is very low." }
    ]
  }
];
